'use client';

import Icon from '@/components/ui/AppIcon';

interface SortControlsProps {
  currentSort: string;
  onSortChange: (sort: string) => void;
  resultCount: number;
}

const SortControls = ({ currentSort, onSortChange, resultCount }: SortControlsProps) => {
  const sortOptions = [
    { value: 'distance', label: 'Distance', icon: 'MapPinIcon' },
    { value: 'rating', label: 'Rating', icon: 'StarIcon' },
    { value: 'specialization', label: 'Best Match', icon: 'SparklesIcon' }
  ];

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 bg-card rounded-lg p-4 shadow-elevation-sm">
      <div className="flex items-center space-x-2">
        <Icon name="AdjustmentsHorizontalIcon" size={20} className="text-primary" />
        <span className="font-body text-sm text-text-secondary">
          <span className="font-medium text-text-primary">{resultCount}</span> mechanics found
        </span>
      </div>

      <div className="flex items-center space-x-2 w-full sm:w-auto">
        <span className="font-caption text-xs font-medium text-text-secondary whitespace-nowrap">
          Sort by:
        </span>
        <div className="flex items-center space-x-1 flex-1 sm:flex-initial">
          {sortOptions.map((option) => (
            <button
              key={option.value}
              onClick={() => onSortChange(option.value)}
              className={`flex items-center space-x-1 rounded-lg px-3 py-2 font-body text-sm font-medium transition-smooth ${
                currentSort === option.value
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted text-text-secondary hover:bg-primary/10 hover:text-primary'
              }`}
            >
              <Icon name={option.icon as any} size={16} />
              <span className="hidden sm:inline">{option.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SortControls;